import { useCallback, useEffect, useState } from 'react';
import BigButton from '../../button/BigButton';
import Input from '../../form/Input';
import { useFranchiseStore } from '../../../store/useFranchise';

/**
 * @author taulmax
 * @date 2024.12.13
 * @description 복비 충전 모달
 */
const ChargeModal = ({
  id,
  setId,
  companyName,
  setCompanyName,
  isOpen,
  setIsOpen,
}: {
  id: string;
  setId: React.Dispatch<React.SetStateAction<string>>;
  companyName: string;
  setCompanyName: React.Dispatch<React.SetStateAction<string>>;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { chargeFranchise } = useFranchiseStore();

  const [bokbi, setBokbi] = useState<string>('');
  const onChangeBokbi = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.replace(/[^0-9]/g, ''); // 숫자 이외의 문자 제거
      if (value === '') {
        setBokbi(''); // 빈 값일 때 그대로 유지
      } else {
        const numericValue = Math.min(Number(value), 10000000); // 1000만원 넘지 않게 제한
        const formattedValue = numericValue.toLocaleString(); // 천단위 콤마 추가
        setBokbi(formattedValue);
      }
    },
    []
  );

  const [memo, setMemo] = useState<string>('');
  const onChangeMemo = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setMemo(e.target.value);
  }, []);

  const onClickCancel = useCallback(() => {
    setId('');
    setIsOpen(false);
    setCompanyName('');
    setBokbi('');
    setMemo('');
  }, [setCompanyName, setId, setIsOpen]);

  const onClickBokbi = useCallback(() => {
    const franchiseData: { chargeAmount: number; memo: string } = {
      chargeAmount: parseInt(bokbi.replaceAll(',', '')),
      memo: memo,
    };
    chargeFranchise(id, franchiseData);
    onClickCancel();
  }, [bokbi, chargeFranchise, id, memo, onClickCancel]);

  // ESC key event handler
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClickCancel();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClickCancel]);

  return (
    <div
      style={{ display: isOpen ? 'flex' : 'none' }}
      className="session_expired_modal_bg"
    >
      <div className="session_expired_modal">
        <div className="session_expired_info">
          <h1 style={{ lineHeight: '34px', paddingBottom: 24 }}>
            복비를 충전해주세요
          </h1>
          <div style={{ padding: '16px 0px 8px 0px', fontSize: 20 }}>
            <b style={{ color: '#cb1301' }}>"{companyName}"</b>의 복비를
            충전합니다.
          </div>
          <span style={{ padding: '24px 0px 40px 0px', margin: 0 }}>
            복비 충전의 최대금액은 <b>10,000,000원 (1000만원)</b> 까지 입니다.
          </span>
          <Input
            value={bokbi}
            onChange={onChangeBokbi}
            placeholder="10,000,000"
            style={{ marginBottom: 8 }}
          />
          <Input
            value={memo}
            onChange={onChangeMemo}
            placeholder="메모 / ex. 가불"
            style={{ marginBottom: 24 }}
          />
          <BigButton type="submit" text="복비 충전" onClick={onClickBokbi} />
          <BigButton
            type="update"
            text="닫기"
            style={{ marginTop: 8 }}
            onClick={onClickCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default ChargeModal;
